import { brand } from "@/shared/lib/safecheckBrand";
import providerMedicalActsData from "./data/providerMedicalActs.json";

export const employees: Employee[] = [
  {
    id: "1",
    photo: "https://i.pravatar.cc/48?img=12",
    name: "ABEMBA ATEBA Juvenal",
    systemId: "SFC0463",
    companyMatricule: "680",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    province: "Kinshasa",
    branch: "Direction Financière",
    status: "active",
  },
  {
    id: "2",
    photo: "https://i.pravatar.cc/48?img=33",
    name: "KALONJI KALONJI PAQUES",
    systemId: "SFC0477",
    companyMatricule: "712",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    province: "Kinshasa",
    branch: "Direction Générale",
    status: "active",
  },
  {
    id: "3",
    photo: "https://i.pravatar.cc/48?img=8",
    name: "KAMBOLO MAKOKO Jean",
    systemId: "SFC0389",
    companyMatricule: "445",
    company: "Medecin de nuit",
    province: "Kinshasa",
    branch: "Antenne Centrale",
    status: "active",
  },
];

/** Employés CEEC — compte entreprise */
export const enterpriseEmployees: Employee[] = [
  {
    id: "ent-emp-0",
    photo: "",
    name: "MWEMA MUNGU",
    systemId: "SFC0002",
    companyMatricule: "982",
    company: "ceec",
    province: "Kinshasa",
    branch: "Direction Générale",
    status: "active",
  },
  {
    id: "ent-emp-1",
    photo: "",
    name: "ABEMBA ATEBA Juvenal",
    systemId: "SFC0463",
    companyMatricule: "680",
    company: "ceec",
    province: "Kinshasa",
    branch: "Direction Financière",
    status: "active",
  },
  {
    id: "ent-emp-2",
    photo: "",
    name: "KALONJI KALONJI PAQUES",
    systemId: "SFC0477",
    companyMatricule: "712",
    company: "ceec",
    province: "Kinshasa",
    branch: "Direction Générale",
    status: "active",
  },
  {
    id: "ent-emp-3",
    photo: "",
    name: "MUKENDI TSHILOMBO Marie",
    systemId: "SFC0512",
    companyMatricule: "801",
    company: "ceec",
    province: "Kinshasa",
    branch: "Ressources Humaines",
    status: "active",
  },
  {
    id: "ent-emp-4",
    photo: "",
    name: "KABONGO MULUMBA Paul",
    systemId: "SFC0498",
    companyMatricule: "756",
    company: "ceec",
    province: "Kinshasa",
    branch: "Direction Financière",
    status: "active",
  },
  {
    id: "ent-emp-5",
    photo: "",
    name: "LUBOYA KASONGO Grace",
    systemId: "SFC0520",
    companyMatricule: "823",
    company: "ceec",
    province: "Kinshasa",
    branch: "Communication",
    status: "active",
  },
  {
    id: "ent-emp-6",
    photo: "",
    name: "NTUMBA ILUNGA David",
    systemId: "SFC0441",
    companyMatricule: "634",
    company: "ceec",
    province: "Kinshasa",
    branch: "Direction Générale",
    status: "active",
  },
  {
    id: "ent-emp-7",
    photo: "",
    name: "MULONGO KAPENGA Sarah",
    systemId: "SFC0533",
    companyMatricule: "845",
    company: "ceec",
    province: "Kinshasa",
    branch: "Ressources Humaines",
    status: "active",
  },
  {
    id: "ent-emp-8",
    photo: "",
    name: "KASONGO MBIYA Joseph",
    systemId: "SFC0428",
    companyMatricule: "612",
    company: "ceec",
    province: "Kinshasa",
    branch: "Direction Financière",
    status: "inactive",
  },
  {
    id: "ent-emp-9",
    photo: "",
    name: "BUYA TSHISEKEDI Anne",
    systemId: "SFC0545",
    companyMatricule: "867",
    company: "ceec",
    province: "Kinshasa",
    branch: "Communication",
    status: "active",
  },
  {
    id: "ent-emp-10",
    photo: "",
    name: "KAPENGA MULUMBA Eric",
    systemId: "SFC0415",
    companyMatricule: "598",
    company: "ceec",
    province: "Kinshasa",
    branch: "Direction Générale",
    status: "active",
  },
  {
    id: "ent-emp-11",
    photo: "",
    name: "TSHILOMBO KABONGO Ruth",
    systemId: "SFC0558",
    companyMatricule: "891",
    company: "ceec",
    province: "Kinshasa",
    branch: "Ressources Humaines",
    status: "active",
  },
  {
    id: "ent-emp-12",
    photo: "",
    name: "ILUNGA MUKENDI Patrick",
    systemId: "SFC0402",
    companyMatricule: "571",
    company: "ceec",
    province: "Kinshasa",
    branch: "Direction Financière",
    status: "active",
  },
];

export const userAccounts: UserAccount[] = [
  { id: "9", name: "CENTRE HOSPITALIER MONKOLE", email: "chm@safecheckrdc.com", role: "hospital", initial: "C" },
  { id: "8", name: "Medecin de nuit", email: "mdn@safecheckrdc.com", role: "hospital", initial: "M" },
  { id: "7", name: "sndaya", email: "s.ndaya@safecheck-rdc.com", role: "admin", initial: "S" },
  { id: "6", name: "Dr Elvis Katuala", email: "e.katuala@safecheck-rdc.com", role: "auditor", initial: "D" },
  { id: "5", name: "afiadonbosco", email: "contact@afiadonbosco.cd", role: "hospital", initial: "A" },
  { id: "4", name: "mwangeji", email: "admin@mwangeji.cd", role: "hospital", initial: "M" },
  { id: "3", name: "ceec", email: "support@ceec.cd", role: "enterprise", initial: "C" },
  { id: "2", name: "audit.rdc", email: "audit@safecheck-rdc.com", role: "auditor", initial: "A" },
  { id: "1", name: "hgr.kintambo", email: "hgr@safecheckrdc.com", role: "hospital", initial: "H" },
];

export const userRoleOptions = [
  { value: "", label: "Tous les rôles" },
  { value: "admin", label: "Admin" },
  { value: "auditor", label: "Auditeur" },
  { value: "enterprise", label: "Entreprise" },
  { value: "hospital", label: "Hôpital" },
];

export const providers: Provider[] = [
  {
    id: "147",
    commercialName: "VITAPHARMA",
    type: "PHARMACIE",
    city: "KINSHASA",
    province: "Kinshasa",
    phone: "+243 81 234 5678",
    email: "contact@vitapharma.cd",
    status: "active",
  },
  {
    id: "143",
    commercialName: "POLYCLINIQUE SAINT LUC / KGA",
    type: "HÔPITAL",
    city: "KANANGA",
    province: "Kasaï-Central",
    phone: "+243 82 345 6789",
    email: "contact@saintluc-kga.cd",
    status: "active",
  },
  {
    id: "142",
    commercialName: "IMCK TSHIKAJI",
    type: "HÔPITAL",
    city: "KANANGA",
    province: "Kasaï-Central",
    phone: "+243 99 456 7890",
    email: "info@imck.cd",
    status: "active",
  },
  {
    id: "136",
    commercialName: "SKYBORNE",
    type: "HÔPITAL",
    city: "KIKWIT",
    province: "Kwilu",
    phone: "+243 81 234 5678",
    email: "contact@skyborne.cd",
    status: "active",
  },
  {
    id: "121",
    commercialName: "CLINIQUE PEDIATRIQUE DE MBUJI-MAYI",
    type: "HÔPITAL",
    city: "MBUJI-MAYI",
    province: "Kasaï-Oriental",
    phone: "+243 82 345 6789",
    email: "pediatrique@mbuji.cd",
    status: "active",
  },
  {
    id: "120",
    commercialName: "HOPITAL VALENTIN DISSAHI",
    type: "HÔPITAL",
    city: "MBUJI-MAYI",
    province: "Kasaï-Oriental",
    phone: "+243 99 456 7890",
    email: "contact@dissahi.cd",
    status: "active",
  },
  {
    id: "86",
    commercialName: "CENTRE MEDICAL DIAMANT",
    type: "HÔPITAL",
    city: "LUBUMBASHI",
    province: "Haut-Katanga",
    phone: "+243 89 222 3333",
    email: "diamant@medical.cd",
    status: "active",
  },
  {
    id: "82",
    commercialName: "NGALIEMA CENTER (NEW DEAL MEDICAL)",
    type: "HÔPITAL",
    city: "KINSHASA",
    province: "Kinshasa",
    phone: "+243 81 555 9999",
    email: "newdeal@ngaliema.cd",
    status: "active",
  },
  {
    id: "63",
    commercialName: "SPIX CABINET DENTAIRE",
    type: "CABINET MÉDICAL",
    city: "KINSHASA",
    province: "Kinshasa",
    phone: "+243 97 111 0000",
    email: "spix@cabinet.cd",
    status: "active",
  },
];

export const beneficiaries: Beneficiary[] = [
  {
    id: "1",
    photo: "https://i.pravatar.cc/48?img=5",
    name: "1. IMANI BIESA TUMBA",
    relation: "ENFANT",
    birthDate: "08/01/2023",
    age: "3 ans",
    gender: "F",
    employee: "KALONJI KALONJI PAQUES",
    matricule: "SFC0477",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
  {
    id: "2",
    photo: "https://i.pravatar.cc/48?img=9",
    name: "2. MUKENDI TSHILOMBO Grace",
    relation: "CONJOINT",
    birthDate: "15/06/1990",
    age: "35 ans",
    gender: "F",
    employee: "ABEMBA ATEBA Juvenal",
    matricule: "SFC0463",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
  {
    id: "3",
    photo: "https://i.pravatar.cc/48?img=12",
    name: "1. MBAYA MBUKA DIANTENTE",
    relation: "ENFANT",
    birthDate: "18/04/2013",
    age: "13 ans",
    gender: "F",
    employee: "KIMFULA NKEBOLO NAOMIE",
    matricule: "SFC0517",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
  {
    id: "4",
    photo: "https://i.pravatar.cc/48?img=15",
    name: "1. MPUNGA DINSAKA Realdite",
    relation: "ENFANT",
    birthDate: "04/05/2024",
    age: "2 ans",
    gender: "F",
    employee: "KAJA KATALA",
    matricule: "SFC0329",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
  {
    id: "5",
    photo: "https://i.pravatar.cc/48?img=20",
    name: "1. MUKABE KAYABA",
    relation: "ENFANT",
    birthDate: "04/09/2022",
    age: "3 ans",
    gender: "M",
    employee: "ILUNGA MVUMBA",
    matricule: "SFC0227",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
  {
    id: "6",
    photo: "https://i.pravatar.cc/48?img=24",
    name: "1. TSHIENGEJI MUNGENGE Kevine",
    relation: "ENFANT",
    birthDate: "23/03/2010",
    age: "16 ans",
    gender: "F",
    employee: "NGOIE WA BANZA Franck cherife",
    matricule: "SFC0048",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
  {
    id: "7",
    photo: "https://i.pravatar.cc/48?img=28",
    name: "2. KAIKA MOBWA KAELWIN",
    relation: "ENFANT",
    birthDate: "17/02/2025",
    age: "1 ans",
    gender: "M",
    employee: "ILUNGA MVUMBA",
    matricule: "SFC0227",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
  {
    id: "8",
    photo: "https://i.pravatar.cc/48?img=31",
    name: "2. KATANGA KAMUKUBA Anah",
    relation: "ENFANT",
    birthDate: "30/11/2020",
    age: "5 ans",
    gender: "-",
    employee: "MUKWIYO MUKALO",
    matricule: "SFC0588",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
  {
    id: "9",
    photo: "https://i.pravatar.cc/48?img=35",
    name: "2. LISEKO MISENGA MPALA Marianne",
    relation: "ENFANT",
    birthDate: "-",
    age: "",
    gender: "F",
    employee: "BOSILIKWA IFASO",
    matricule: "SFC0507",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
  {
    id: "10",
    photo: "https://i.pravatar.cc/48?img=39",
    name: "3. LISEKO NZONGA Merveille",
    relation: "ENFANT",
    birthDate: "-",
    age: "",
    gender: "F",
    employee: "BOSILIKWA IFASO",
    matricule: "SFC0507",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
  {
    id: "11",
    photo: "https://i.pravatar.cc/48?img=42",
    name: "3. YAM MWEHU MARISSA",
    relation: "ENFANT",
    birthDate: "24/01/2007",
    age: "19 ans",
    gender: "F",
    employee: "KAJ MWAD Daniella",
    matricule: "SFC0134",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
  {
    id: "12",
    photo: "https://i.pravatar.cc/48?img=45",
    name: "3. MUJINGA MUTANDA Mila",
    relation: "ENFANT",
    birthDate: "-",
    age: "",
    gender: "F",
    employee: "MUTANDA MUTANDA",
    matricule: "SFC0309",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
  {
    id: "13",
    photo: "https://i.pravatar.cc/48?img=48",
    name: "4. MAWANZA MATA LAMBA Benjamin Junior",
    relation: "ENFANT",
    birthDate: "05/04/2022",
    age: "4 ans",
    gender: "M",
    employee: "GABUBA MANUNGA HUGUETTE",
    matricule: "SFC0459",
    company: "Centre d'Expertise d'Évaluation et de Certification (CEEC)",
    status: "active",
  },
];

export const CEEC_COMPANY_LABEL =
  "Centre d'Expertise d'Evaluation et de Certification (CEEC)";

/** Bénéficiaires CEEC — compte entreprise */
export const enterpriseBeneficiaries: Beneficiary[] = beneficiaries
  .filter((beneficiary) => beneficiary.company.includes("CEEC"))
  .map((beneficiary) => ({
    ...beneficiary,
    company: CEEC_COMPANY_LABEL,
    companyMatricule:
      beneficiary.id === "1"
        ? "982"
        : String(620 + Number.parseInt(beneficiary.id, 10) * 13),
  }));

export function searchAdmissionPatients(query: string): AdmissionPatientCandidate[] {
  const normalized = query.trim().toUpperCase();
  if (!normalized) return [];

  const results: AdmissionPatientCandidate[] = [];
  const seen = new Set<string>();

  for (const employee of enterpriseEmployees) {
    if (!employee.systemId.toUpperCase().includes(normalized)) continue;
    const key = `employee-${employee.systemId}`;
    if (seen.has(key)) continue;
    seen.add(key);
    results.push({
      id: key,
      name: employee.name,
      systemId: employee.systemId,
      type: "employee",
      company: employee.company,
    });
  }

  for (const beneficiary of enterpriseBeneficiaries) {
    if (!beneficiary.matricule.toUpperCase().includes(normalized)) continue;
    const key = `beneficiary-${beneficiary.matricule}`;
    if (seen.has(key)) continue;
    seen.add(key);
    results.push({
      id: key,
      name: beneficiary.name,
      systemId: beneficiary.matricule,
      type: "beneficiary",
      company: beneficiary.company,
      subtitle: beneficiary.employee,
    });
  }

  return results;
}

export const admissions: Admission[] = [
  {
    id: "1",
    date: "24/06/2026",
    time: "10:28",
    patient: "NTOMENA NSUNDA",
    patientSub: "SFC0401",
    patientType: "employee",
    hospital: "Medecin de nuit",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    status: "inProgress",
  },
  {
    id: "2",
    date: "24/06/2026",
    time: "09:15",
    patient: "KAMBOLO MAKOKO",
    patientSub: "SFC0389",
    patientType: "employee",
    hospital: "Medecin de nuit",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    status: "inProgress",
  },
  {
    id: "3",
    date: "23/06/2026",
    time: "18:42",
    patient: "LUSHIMBA NGOLO Jacqueline",
    patientSub: "SFC0376",
    patientType: "beneficiary",
    hospital: "Medecin de nuit",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    status: "inProgress",
  },
  {
    id: "4",
    date: "23/06/2026",
    time: "14:30",
    patient: "MULONGO TSHILOMBO",
    patientSub: "SFC0312",
    patientType: "employee",
    hospital: "Polyclinique Afia Don Bosco",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    status: "inProgress",
  },
  {
    id: "5",
    date: "22/06/2026",
    time: "08:05",
    patient: "KABONGO MUKENDI",
    patientSub: "Enfant Kabongo",
    patientType: "beneficiary",
    hospital: "Clinique Saint Luc",
    company: "Medecin de nuit",
    status: "inProgress",
  },
  {
    id: "6",
    date: "21/06/2026",
    time: "16:20",
    patient: "NZUZI LUBAKA",
    patientSub: "SFC0298",
    patientType: "employee",
    hospital: "Medecin de nuit",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    status: "completed",
  },
  {
    id: "7",
    date: "20/06/2026",
    time: "11:55",
    patient: "TSHILENGE KASONGO",
    patientSub: "SFC0281",
    patientType: "employee",
    hospital: "Hôpital Général de Kinshasa",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    status: "inProgress",
  },
  {
    id: "8",
    date: "19/06/2026",
    time: "07:40",
    patient: "MATELE MATELE",
    patientSub: "Conjoint Matele",
    patientType: "beneficiary",
    hospital: "Medecin de nuit",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    status: "inProgress",
  },
];

/** Admissions CEEC — compte entreprise */
export const enterpriseAdmissions: Admission[] = [
  {
    id: "ent-adm-1",
    date: "26/06/2026",
    time: "09:43",
    patient: "MWEMA",
    patientSub: "MUNGU",
    patientType: "beneficiary",
    hospital: "Medecin de nuit",
    company: CEEC_COMPANY_LABEL,
    status: "inProgress",
    motif: "Admission SafeCheck",
  },
  {
    id: "ent-adm-2",
    date: "26/06/2026",
    time: "08:17",
    patient: "KALONJI",
    patientSub: "PAQUES",
    patientType: "employee",
    hospital: "Medecin de nuit",
    company: CEEC_COMPANY_LABEL,
    status: "inProgress",
    motif: "Admission SafeCheck",
  },
  {
    id: "ent-adm-3",
    date: "26/06/2026",
    time: "07:55",
    patient: "ABEMBA",
    patientSub: "JUVENAL",
    patientType: "employee",
    hospital: "Medecin de nuit",
    company: CEEC_COMPANY_LABEL,
    status: "inProgress",
    motif: "Admission SafeCheck",
  },
  {
    id: "ent-adm-4",
    date: "25/06/2026",
    time: "18:22",
    patient: "IMANI",
    patientSub: "TUMBA",
    patientType: "beneficiary",
    hospital: "Medecin de nuit",
    company: CEEC_COMPANY_LABEL,
    status: "inProgress",
    motif: "Admission SafeCheck",
  },
  {
    id: "ent-adm-5",
    date: "25/06/2026",
    time: "14:08",
    patient: "MUKENDI",
    patientSub: "MARIE",
    patientType: "beneficiary",
    hospital: "Medecin de nuit",
    company: CEEC_COMPANY_LABEL,
    status: "inProgress",
    motif: "Admission SafeCheck",
  },
  {
    id: "ent-adm-6",
    date: "25/06/2026",
    time: "11:31",
    patient: "KABONGO",
    patientSub: "PAUL",
    patientType: "employee",
    hospital: "Medecin de nuit",
    company: CEEC_COMPANY_LABEL,
    status: "inProgress",
    motif: "Admission SafeCheck",
  },
  {
    id: "ent-adm-7",
    date: "24/06/2026",
    time: "16:45",
    patient: "BUKASA",
    patientSub: "BUKASA",
    patientType: "employee",
    hospital: "Medecin de nuit",
    company: CEEC_COMPANY_LABEL,
    status: "inProgress",
    motif: "Admission SafeCheck",
  },
  {
    id: "ent-adm-8",
    date: "24/06/2026",
    time: "10:28",
    patient: "LUSHIMBA",
    patientSub: "NGOLO",
    patientType: "beneficiary",
    hospital: "Medecin de nuit",
    company: CEEC_COMPANY_LABEL,
    status: "inProgress",
    motif: "Admission SafeCheck",
  },
];

/** Admissions prestataire Medecin de nuit */
export const hospitalAdmissions: Admission[] = enterpriseAdmissions;

/** Litiges prestataire Medecin de nuit */
export const hospitalDisputes: Dispute[] = [];

/** Tous les litiges — admin / auditeur / hôpital */
export const allDisputesList: DisputeListItem[] = [];

export const disputeStatusFilterOptions = [
  { value: "", label: "Tous les statuts" },
  { value: "inProgress", label: "En cours" },
  { value: "resolved", label: "Traité" },
  { value: "rejected", label: "Rejeté" },
] as const;

export const processedDisputeStatusFilterOptions = [
  { value: "closed", label: "Clôturé" },
  { value: "resolved", label: "Traité" },
  { value: "rejected", label: "Rejeté" },
] as const;

export const PROCESSED_DISPUTE_DEFAULT_STATUS = "closed" as const;

export {
  adminChatMessages,
  adminMessageThreads,
  auditorChatMessages,
  auditorMessageThreads,
  enterpriseChatMessages,
  enterpriseMessageThreads,
  hospitalChatMessages,
  hospitalMessageThreads,
} from "./data/messaging";

/** Profil utilisateur CEEC — compte entreprise */
export const enterpriseUserProfile: EnterpriseUserProfile = {
  photo: "/CEEC.jpg",
  username: "ceec",
  email: "ceec@safecheckrdc.com",
  companyName: CEEC_COMPANY_LABEL,
  shortName: "ceec",
  address: "n°3989 av des cliniques kinshasa/gombe",
  phone: "+243 860 406 957",
};

/** Profil utilisateur Medecin de nuit — compte prestataire */
export const hospitalUserProfile: EnterpriseUserProfile = {
  photo: "/mdn-2.png",
  username: "mdn",
  email: "mdn@safecheckrdc.com",
  companyName: "Medecin de nuit",
  shortName: "mdn",
  address: "Avenue de la Science, Kinshasa/Gombe",
  phone: "+243 810 203 040",
};

/** Profil entreprise CEEC */
export const enterpriseCompanyProfile: EnterpriseCompanyProfile = {
  name: CEEC_COMPANY_LABEL,
};

export const admissionStatusOptions = [
  { value: "", label: "Tous les statuts" },
  { value: "inProgress", label: "En cours" },
  { value: "completed", label: "Terminée" },
  { value: "cancelled", label: "Annulée" },
];

export const admissionPatientTypeOptions = [
  { value: "", label: "Tous les types" },
  { value: "employee", label: "Assuré" },
  { value: "beneficiary", label: "Ayant droit" },
];

export const hospitals = [
  "afiadonbosco",
  "mwangeji",
  "Medecin de nuit",
  "CENTRE HOSPITALIER MONKOLE",
  "CENTRE MEDICALE DE LA MONGALA",
  "CLINIQUE DE L'ESPERANCE",
  "CLINIQUE BUCCO-DENTAIRE DIVINE",
  "CLINIQUE BILAN",
  "ARIEL MEDICAL INSTITUTE",
  "HOPITAL FAKAM",
  "CENTRE BOTOUR",
  "CENTRE DE DIAGNOSTIC EYANO",
  "CENTRE MEDICAL MEGUMI",
  "CENTRE HOSPITALIER NOTRE DAME",
  "CLINIQUE CENTRALE DE (KIKWIT) KWILU",
] as const;

function toHospitalSelectOptions(allLabel: string) {
  return [
    { value: "", label: allLabel },
    ...hospitals.map((name) => ({ value: name, label: name })),
  ];
}

export const companies = [
  "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
  "SAPHIR RDC",
] as const;

function toCompanySelectOptions(allLabel: string) {
  return [
    { value: "", label: allLabel },
    ...companies.map((name) => ({ value: name, label: name })),
  ];
}

export const admissionHospitalFilterOptions = toHospitalSelectOptions("Tous les hôpitaux");

export const admissionCompanyFilterOptions = toCompanySelectOptions("Toutes les entreprises");

export const packages: Package[] = [
  {
    id: "1",
    code: "PKG-2026-MWA-CEN-001",
    name: "PACKAGE FORFAIT MWANGEJI CEEC OCTOBRE 2025",
    hospital: "mwangeji",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    monthlyRate: "80.00 USD",
    periodStart: "01/10/2025",
    periodEnd: "31/10/2026",
    includedActs: 18,
    excludedActs: 420,
    status: "active",
  },
  {
    id: "2",
    code: "PKG-2026-MED-CEN-001",
    name: "MDN-CEEC-HF-FEV-2026",
    hospital: "Medecin de nuit",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    monthlyRate: "250.00 USD",
    periodStart: "01/02/2026",
    periodEnd: "28/02/2026",
    includedActs: 25,
    excludedActs: 1320,
    status: "active",
  },
  {
    id: "3",
    code: "PKG-2026-AFI-CEN-001",
    name: "AFIADON-CEEC-HF-FEV-2026",
    hospital: "afiadonbosco",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    monthlyRate: "200.00 USD",
    periodStart: "01/02/2026",
    periodEnd: "28/02/2026",
    includedActs: 22,
    excludedActs: 510,
    status: "active",
  },
];

export const packageStatusOptions = [
  { value: "", label: "Tous les statuts" },
  { value: "active", label: "Actif" },
  { value: "draft", label: "Brouillon" },
  { value: "suspended", label: "Suspendu" },
];

export const packageHospitalFilterOptions = toHospitalSelectOptions("Tous les hôpitaux");

export const packageCompanyFilterOptions = toCompanySelectOptions("Toutes les entreprises");

export const conventions: Convention[] = [
  {
    id: "1",
    code: "CONV-2024-4-48CD9",
    name: "CONVENTION-SAFECHECK-CEEC",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    providerCount: 3,
    type: "forfaitaire",
    validityStart: "01/11/2025",
    validityEnd: "01/11/2027",
    budget: 0,
    consumptionPct: 0,
    status: "active",
  },
];

export const conventionStatusOptions = [
  { value: "", label: "Tous les statuts" },
  { value: "active", label: "Active" },
  { value: "expiring", label: "Expire bientôt" },
  { value: "expired", label: "Expirée" },
  { value: "draft", label: "Brouillon" },
  { value: "suspended", label: "Suspendue" },
  { value: "cancelled", label: "Annulée" },
];

export const conventionCompanyFilterOptions = toCompanySelectOptions("Toutes les entreprises");

export const conventionProviderFilterOptions = [
  { value: "", label: "Tous les prestataires" },
  { value: "afiadonbosco", label: "afiadonbosco" },
  { value: "mwangeji", label: "mwangeji" },
  { value: "Medecin de nuit", label: "Medecin de nuit" },
];

export const conventionCompanySelectOptions = companies.map((name) => ({
  value: name,
  label: name,
}));

export const conventionTreatmentTypeOptions = [
  { value: "forfaitaire", label: "FORFAITAIRE" },
  { value: "tiers_payant", label: "TIERS PAYANT" },
  { value: "remboursement", label: "REMBOURSEMENT" },
  { value: "mixte", label: "MIXTE" },
];

export const conventionCoverageUnitOptions = [
  { value: "personne", label: "PAR PERSONNE" },
  { value: "famille", label: "PAR FAMILLE" },
  { value: "mixte", label: "MIXTE" },
];

export const conventionBudgetPeriodicityOptions = [
  { value: "trimestriel", label: "TRIMESTRIEL" },
  { value: "semestriel", label: "SEMESTRIEL" },
  { value: "annuel", label: "ANNUEL" },
];

export const conventionCoveredProviderOptions = [
  {
    value: "CLINIQUE CENTRALE DE (KIKWIT) KWILU",
    label: "CLINIQUE CENTRALE DE (KIKWIT) KWILU (Hopital)",
  },
  {
    value: "ARIEL MEDICAL INSTITUTE",
    label: "ARIEL MEDICAL INSTITUTE (Hopital) — KINSHASA",
  },
  { value: "CENTRE BOTOUR", label: "CENTRE BOTOUR (Hopital) — KINSHASA" },
  {
    value: "CENTRE DE DIAGNOSTIC EYANO",
    label: "CENTRE DE DIAGNOSTIC EYANO (Hopital) — KINSHASA",
  },
  {
    value: "CENTRE HOSPITALIER MONKOLE",
    label: "CENTRE HOSPITALIER MONKOLE (Hopital) — KINSHASA",
  },
  {
    value: "CENTRE HOSPITALIER NOTRE DAME",
    label: "CENTRE HOSPITALIER NOTRE DAME (Hopital) — MBUJI-MAYI",
  },
  { value: "afiadonbosco", label: "afiadonbosco (Hopital)" },
  { value: "mwangeji", label: "mwangeji (Hopital)" },
  { value: "Medecin de nuit", label: "Medecin de nuit (Hopital)" },
  {
    value: "CENTRE MEDICALE DE LA MONGALA",
    label: "CENTRE MEDICALE DE LA MONGALA (Hopital)",
  },
  { value: "CLINIQUE DE L'ESPERANCE", label: "CLINIQUE DE L'ESPERANCE (Hopital)" },
  {
    value: "CLINIQUE BUCCO-DENTAIRE DIVINE",
    label: "CLINIQUE BUCCO-DENTAIRE DIVINE (Hopital)",
  },
  { value: "CLINIQUE BILAN", label: "CLINIQUE BILAN (Hopital)" },
  { value: "HOPITAL FAKAM", label: "HOPITAL FAKAM (Hopital)" },
  { value: "CENTRE MEDICAL MEGUMI", label: "CENTRE MEDICAL MEGUMI (Hopital)" },
];

export const authorizationRequestSummary = {
  total: 170,
  pending: 16,
  approved: 147,
  rejected: 7,
};

export const authorizationRequestStatusOptions = [
  { value: "", label: "Tous" },
  { value: "pending", label: "En attente" },
  { value: "approved", label: "Approuvée" },
  { value: "rejected", label: "Rejetée" },
];

export const authorizationRequestUrgencyOptions = [
  { value: "", label: "Toutes" },
  { value: "normal", label: "Normal" },
  { value: "urgent", label: "Urgent" },
];

export const authorizationRequests: AuthorizationRequest[] = [
  {
    id: "182",
    patient: "KALONJI MERIKIAS",
    patientId: "SFC0378",
    packageCode: "PKG-2026-MED-CEN-001",
    packageRef: "MDN-CEEC-HF-FEV-2026",
    hospital: "Medecin de nuit",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    urgency: "normal",
    date: "23/06/2026",
    status: "pending",
  },
  {
    id: "181",
    patient: "MUKENDI TSHILOMBO Marie",
    patientId: "SFC0377",
    packageCode: "PKG-2026-MED-CEN-001",
    packageRef: "MDN-CEEC-HF-FEV-2026",
    hospital: "Medecin de nuit",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    urgency: "normal",
    date: "22/06/2026",
    status: "approved",
  },
  {
    id: "180",
    patient: "LUSHIMBA NGOLO Jacqueline",
    patientId: "SFC0376",
    packageCode: "PKG-2026-MED-CEN-001",
    packageRef: "MDN-CEEC-HF-FEV-2026",
    hospital: "Medecin de nuit",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    urgency: "urgent",
    date: "21/06/2026",
    status: "pending",
  },
  {
    id: "179",
    patient: "KAMBOLO MAKOKO Jean",
    patientId: "SFC0389",
    packageCode: "PKG-2026-AFI-CEN-001",
    packageRef: "AFIADON-CEEC-HF-FEV-2026",
    hospital: "afiadonbosco",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    urgency: "normal",
    date: "20/06/2026",
    status: "approved",
  },
  {
    id: "178",
    patient: "KABONGO MULUMBA Paul",
    patientId: "SFC0362",
    packageCode: "PKG-2026-MWA-CEN-001",
    packageRef: "PACKAGE FORFAIT MWANGEJI CEEC OCTOBRE 2025",
    hospital: "mwangeji",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    urgency: "normal",
    date: "19/06/2026",
    status: "rejected",
  },
  {
    id: "177",
    patient: "NTUMBA KASONGO Anne",
    patientId: "SFC0355",
    packageCode: "PKG-2026-MED-CEN-001",
    packageRef: "MDN-CEEC-HF-FEV-2026",
    hospital: "Medecin de nuit",
    company: "SAPHIR RDC",
    urgency: "urgent",
    date: "18/06/2026",
    status: "pending",
  },
  {
    id: "176",
    patient: "ILUNGA KAPENGA David",
    patientId: "SFC0348",
    packageCode: "PKG-2026-MWA-CEN-001",
    packageRef: "PACKAGE FORFAIT MWANGEJI CEEC OCTOBRE 2025",
    hospital: "mwangeji",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    urgency: "normal",
    date: "17/06/2026",
    status: "approved",
  },
  {
    id: "175",
    patient: "MULONGO TSHISEKEDI Grace",
    patientId: "SFC0331",
    packageCode: "PKG-2026-AFI-CEN-001",
    packageRef: "AFIADON-CEEC-HF-FEV-2026",
    hospital: "afiadonbosco",
    company: "SAPHIR RDC",
    urgency: "normal",
    date: "16/06/2026",
    status: "approved",
  },
  {
    id: "174",
    patient: "BUYA KASAI Luc",
    patientId: "SFC0324",
    packageCode: "PKG-2026-MED-CEN-001",
    packageRef: "MDN-CEEC-HF-FEV-2026",
    hospital: "Medecin de nuit",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    urgency: "normal",
    date: "15/06/2026",
    status: "pending",
  },
  {
    id: "173",
    patient: "KASONGO MUKENDI Sarah",
    patientId: "SFC0318",
    packageCode: "PKG-2026-MWA-CEN-001",
    packageRef: "PACKAGE FORFAIT MWANGEJI CEEC OCTOBRE 2025",
    hospital: "mwangeji",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    urgency: "urgent",
    date: "14/06/2026",
    status: "rejected",
  },
  {
    id: "172",
    patient: "TSHILOMBO KABEYA Eric",
    patientId: "SFC0302",
    packageCode: "PKG-2026-AFI-CEN-001",
    packageRef: "AFIADON-CEEC-HF-FEV-2026",
    hospital: "afiadonbosco",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    urgency: "normal",
    date: "13/06/2026",
    status: "approved",
  },
  {
    id: "171",
    patient: "MPOYI LUBAKI Claire",
    patientId: "SFC0295",
    packageCode: "PKG-2026-MED-CEN-001",
    packageRef: "MDN-CEEC-HF-FEV-2026",
    hospital: "Medecin de nuit",
    company: "SAPHIR RDC",
    urgency: "normal",
    date: "12/06/2026",
    status: "pending",
  },
];

export const adminStats: DashboardStat[] = [
  { id: "invoices", labelKey: "allInvoices", value: "0", icon: "file", color: "text-purple", bg: "bg-purple-soft" },
  { id: "submitted", labelKey: "submittedInvoices", value: "0", icon: "upload", color: "text-yellow", bg: "bg-yellow-soft" },
  { id: "review", labelKey: "reviewInvoices", value: "0", icon: "clock", color: "text-teal", bg: "bg-teal-soft" },
  { id: "approved", labelKey: "approvedInvoices", value: "0", icon: "check", color: "text-green", bg: "bg-teal-soft" },
  { id: "paid", labelKey: "paidInvoices", value: "0", icon: "wallet", color: "text-green", bg: "bg-teal-soft" },
  { id: "admissions", labelKey: "admissions", value: "807", footer: "807 en cours", icon: "home", color: "text-primary", bg: "bg-primary-soft" },
  { id: "modify", labelKey: "modifyInvoices", value: "0", icon: "x", color: "text-pink", bg: "bg-pink-soft" },
  { id: "validation", labelKey: "validationRequests", value: "17", footer: "En attente", icon: "clipboard", color: "text-purple", bg: "bg-purple-soft" },
];

export const auditorStats: DashboardStat[] = [
  { id: "invoices", labelKey: "allInvoices", value: "0", icon: "file", color: "text-purple", bg: "bg-purple-soft" },
  { id: "submitted", labelKey: "submittedInvoices", value: "0", icon: "upload", color: "text-yellow", bg: "bg-yellow-soft" },
  { id: "review", labelKey: "reviewInvoices", value: "0", icon: "clock", color: "text-teal", bg: "bg-teal-soft" },
  { id: "approved", labelKey: "approvedInvoices", value: "0", icon: "check", color: "text-green", bg: "bg-teal-soft" },
  { id: "paid", labelKey: "paidInvoices", value: "0", icon: "wallet", color: "text-green", bg: "bg-teal-soft" },
  { id: "modify", labelKey: "modifyInvoices", value: "0", icon: "x", color: "text-pink", bg: "bg-pink-soft" },
  { id: "validation", labelKey: "validationRequired", value: "17", footer: "Validation requise", footerColor: "text-yellow", icon: "clipboard", color: "text-purple", bg: "bg-purple-soft" },
];

export const hospitalStats: DashboardStat[] = [
  { id: "invoices", labelKey: "allInvoices", value: "0", icon: "file", color: "text-purple", bg: "bg-purple-soft" },
  { id: "submitted", labelKey: "submittedInvoices", value: "0", icon: "upload", color: "text-yellow", bg: "bg-yellow-soft" },
  { id: "paid", labelKey: "paidInvoices", value: "0", icon: "wallet", color: "text-green", bg: "bg-teal-soft" },
  { id: "review", labelKey: "reviewInvoices", value: "0", icon: "clock", color: "text-teal", bg: "bg-teal-soft" },
  { id: "approved", labelKey: "approvedInvoices", value: "0", icon: "check", color: "text-green", bg: "bg-teal-soft" },
  { id: "rejected", labelKey: "rejectedInvoices", value: "0", icon: "x", color: "text-pink", bg: "bg-pink-soft" },
  { id: "revenue", labelKey: "monthlyRevenue", value: "$0", footer: "Ce mois", footerColor: "text-green", icon: "dollar", color: "text-green", bg: "bg-teal-soft" },
];

export const enterpriseStats: DashboardStat[] = [
  { id: "invoices", labelKey: "allInvoices", value: "0", icon: "file", color: "text-purple", bg: "bg-purple-soft" },
  { id: "approved", labelKey: "approvedInvoices", value: "0", icon: "check", color: "text-green", bg: "bg-teal-soft" },
  { id: "expenses", labelKey: "monthlyExpenses", value: "$0", footer: "Ce mois", footerColor: "text-pink", icon: "card", color: "text-pink", bg: "bg-pink-soft" },
  { id: "agents", labelKey: "totalAgents", value: "674", footer: "Assurés", footerColor: "text-purple", icon: "users", color: "text-purple", bg: "bg-purple-soft" },
  { id: "admissions", labelKey: "todayAdmissions", value: "0", footer: "Aujourd'hui", footerColor: "text-teal", icon: "plus", color: "text-teal", bg: "bg-teal-soft" },
  { id: "hf", labelKey: "hfInvoices", value: "0", footer: "Hors forfait", footerColor: "text-yellow", icon: "file", color: "text-muted-foreground", bg: "bg-card-muted" },
  { id: "beneficiaries", labelKey: "beneficiaries", value: "2493", footer: "Bénéficiaires", footerColor: "text-teal", icon: "user", color: "text-teal", bg: "bg-teal-soft" },
];

export const adminAdmissionsTrend = [
  { month: "jan", value: 580 },
  { month: "feb", value: 642 },
  { month: "mar", value: 701 },
  { month: "apr", value: 668 },
  { month: "may", value: 754 },
  { month: "jun", value: 807 },
];

export const adminInvoiceStatus = [
  { key: "submitted", value: 24, color: brand.lime },
  { key: "review", value: 18, color: brand.navyLight },
  { key: "approved", value: 42, color: brand.limeDark },
  { key: "paid", value: 36, color: brand.navy },
  { key: "modify", value: 6, color: brand.navyDark },
];

export const adminRequestSummary = [
  { key: "pending", value: 16, color: brand.lime },
  { key: "approved", value: 8, color: brand.limeDark },
  { key: "rejected", value: 3, color: brand.navyDark },
];

export const adminRecentActivity = [
  { id: "1", type: "admission", time: "10 min" },
  { id: "2", type: "invoice", time: "25 min" },
  { id: "3", type: "request", time: "1 h" },
  { id: "4", type: "employee", time: "2 h" },
  { id: "5", type: "package", time: "3 h" },
];

export const adminPlatformMetrics = [
  { key: "providers", value: 48 },
  { key: "employees", value: 674 },
  { key: "beneficiaries", value: 2493 },
  { key: "packages", value: 12 },
];

export const diseaseChartData = [
  { name: "Paludisme", value: 0.85 },
  { name: "Grippe", value: 0.72 },
  { name: "Hypertension", value: 0.65 },
  { name: "Diabète", value: 0.58 },
  { name: "Anémie", value: 0.45 },
  { name: "Asthme", value: 0.32 },
];

export const invoices: Invoice[] = [
  { id: "1", displayId: 22, reference: "FAC-2026-022", hospital: "Medecin de nuit", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 15282.5, submittedDate: "19/06/2026", period: "Juin 2026", delayDays: 5, status: "pending", reviewStatus: "inReview", createdAt: "2026-06-19 07:46:51", fileName: "3505b9ea-a991-4f02-8490-e8b978f6500d.jpg", urgent: true },
  { id: "2", displayId: 21, reference: "FAC-2026-021", hospital: "afiadonbosco", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 8750, submittedDate: "18/06/2026", period: "Juin 2026", delayDays: 6, status: "pending", reviewStatus: "inReview", createdAt: "2026-06-18 14:22:10", fileName: "invoice-21.pdf", urgent: true },
  { id: "3", displayId: 20, reference: "FAC-2026-020", hospital: "mwangeji", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 3200, submittedDate: "17/06/2026", period: "Juin 2026", delayDays: 7, status: "pending", reviewStatus: "submitted", createdAt: "2026-06-17 11:05:33", fileName: "invoice-20.pdf", urgent: false },
  { id: "4", displayId: 19, reference: "FAC-2026-019", hospital: "Medecin de nuit", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 15600, submittedDate: "16/06/2026", period: "Juin 2026", delayDays: 8, status: "pending", reviewStatus: "inReview", createdAt: "2026-06-16 09:18:44", fileName: "invoice-19.pdf", urgent: true },
  { id: "5", displayId: 18, reference: "FAC-2026-018", hospital: "afiadonbosco", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 980, submittedDate: "15/06/2026", period: "Mai 2026", delayDays: 9, status: "pending", reviewStatus: "inReview", createdAt: "2026-06-15 16:40:02", fileName: "invoice-18.pdf", urgent: false },
  { id: "6", displayId: 17, reference: "FAC-2026-017", hospital: "mwangeji", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 4450, submittedDate: "14/06/2026", period: "Mai 2026", delayDays: 10, status: "pending", reviewStatus: "inReview", createdAt: "2026-06-14 08:55:17", fileName: "invoice-17.pdf", urgent: false },
  { id: "7", displayId: 16, reference: "FAC-2026-016", hospital: "Medecin de nuit", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 22100, submittedDate: "13/06/2026", period: "Mai 2026", delayDays: 11, status: "pending", reviewStatus: "submitted", createdAt: "2026-06-13 13:12:29", fileName: "invoice-16.pdf", urgent: true },
  { id: "8", displayId: 15, reference: "FAC-2026-015", hospital: "afiadonbosco", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 760, submittedDate: "12/06/2026", period: "Mai 2026", delayDays: 12, status: "pending", reviewStatus: "inReview", createdAt: "2026-06-12 10:27:55", fileName: "invoice-15.pdf", urgent: false },
  { id: "9", displayId: 14, reference: "FAC-2026-014", hospital: "mwangeji", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 18900, submittedDate: "11/06/2026", period: "Mai 2026", delayDays: 13, status: "pending", reviewStatus: "inReview", createdAt: "2026-06-11 15:33:41", fileName: "invoice-14.pdf", urgent: true },
  { id: "10", displayId: 13, reference: "FAC-2026-013", hospital: "Medecin de nuit", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 5400, submittedDate: "10/06/2026", period: "Mai 2026", delayDays: 14, status: "pending", reviewStatus: "inReview", createdAt: "2026-06-10 07:51:08", fileName: "invoice-13.pdf", urgent: false },
  { id: "11", displayId: 12, reference: "FAC-2026-012", hospital: "afiadonbosco", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 12300, submittedDate: "09/06/2026", period: "Mai 2026", delayDays: 15, status: "pending", reviewStatus: "pendingAudit", createdAt: "2026-06-09 12:04:22", fileName: "invoice-12.pdf", urgent: false },
  { id: "12", displayId: 11, reference: "FAC-2026-011", hospital: "mwangeji", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 2100, submittedDate: "08/06/2026", period: "Mai 2026", delayDays: 16, status: "pending", reviewStatus: "submitted", createdAt: "2026-06-08 17:19:36", fileName: "invoice-11.pdf", urgent: false },
  { id: "13", displayId: 10, reference: "FAC-2026-010", hospital: "Medecin de nuit", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 6750, submittedDate: "07/06/2026", period: "Mai 2026", delayDays: 17, status: "pending", reviewStatus: "inReview", createdAt: "2026-06-07 06:42:14", fileName: "invoice-10.pdf", urgent: true },
  { id: "14", displayId: 9, reference: "FAC-2026-009", hospital: "afiadonbosco", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 40, submittedDate: "06/06/2026", period: "Mai 2026", delayDays: 17, status: "pending", reviewStatus: "inReview", createdAt: "2026-06-06 11:28:50", fileName: "invoice-9.pdf", urgent: true },
  { id: "15", displayId: 8, reference: "FAC-2026-008", hospital: "mwangeji", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 11200, submittedDate: "06/06/2026", period: "Mai 2026", delayDays: 17, status: "pending", reviewStatus: "inReview", createdAt: "2026-06-06 09:15:03", fileName: "invoice-8.pdf", urgent: true },
  { id: "16", displayId: 7, reference: "FAC-2026-007", hospital: "afiadonbosco", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 9200, submittedDate: "05/06/2026", period: "Mai 2026", delayDays: 18, status: "pending", reviewStatus: "pendingAudit", createdAt: "2026-06-05 14:37:27", fileName: "invoice-7.pdf", urgent: false },
  { id: "17", displayId: 6, reference: "FAC-2026-006", hospital: "mwangeji", company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)", amount: 1480, submittedDate: "04/06/2026", period: "Mai 2026", delayDays: 19, status: "pending", reviewStatus: "inReview", createdAt: "2026-06-04 08:09:45", fileName: "invoice-6.pdf", urgent: false },
];

/** Liste triée pour la page « Toutes les factures » (admin / auditeur) */
export const allInvoicesList: Invoice[] = [
  {
    id: "inv-23",
    displayId: 23,
    reference: "FAC-2026-023",
    hospital: "mwangeji",
    company: "Centre d'Expertise d'Evaluation et de Certification (CEEC)",
    amount: 11120,
    submittedDate: "24/06/2026",
    period: "Juin 2026",
    delayDays: 2,
    status: "pending",
    reviewStatus: "submitted",
    createdAt: "2026-06-24 09:12:00",
    fileName: "invoice-23.pdf",
    urgent: false,
  },
  ...invoices.filter((invoice) => invoice.displayId !== 23),
].sort((a, b) => b.displayId - a.displayId);

const ceecCompany = "Centre d'Expertise d'Evaluation et de Certification (CEEC)";

/** Factures approuvées — admin / auditeur */
export const approvedInvoicesList: Invoice[] = [
  {
    id: "ap-2",
    displayId: 2,
    reference: "FAC-2026-002",
    hospital: "mwangeji",
    company: ceecCompany,
    amount: 8750,
    submittedDate: "20/06/2026",
    period: "Juin 2026",
    delayDays: 6,
    status: "approved",
    reviewStatus: "submitted",
    createdAt: "2026-06-20 10:00:00",
    fileName: "invoice-2.pdf",
    urgent: false,
  },
  {
    id: "ap-1",
    displayId: 1,
    reference: "FAC-2026-001",
    hospital: "afiadonbosco",
    company: ceecCompany,
    amount: 4200,
    submittedDate: "18/06/2026",
    period: "Juin 2026",
    delayDays: 8,
    status: "approved",
    reviewStatus: "inReview",
    createdAt: "2026-06-18 14:00:00",
    fileName: "invoice-1.pdf",
    urgent: false,
  },
];

/** Factures rejetées — admin / auditeur */
export const rejectedInvoicesList: Invoice[] = [];

/** Factures auditées — admin / auditeur */
export const auditedInvoicesList: Invoice[] = [
  {
    id: "aud-12",
    displayId: 12,
    reference: "FAC-2026-012",
    hospital: "Medecin de nuit",
    company: ceecCompany,
    amount: 8450,
    submittedDate: "09/06/2026",
    period: "Juin 2026",
    delayDays: 15,
    status: "approved",
    reviewStatus: "submitted",
    createdAt: "2026-06-09 12:04:22",
    fileName: "invoice-12.pdf",
    urgent: false,
  },
  {
    id: "aud-11",
    displayId: 11,
    reference: "FAC-2026-011",
    hospital: "Medecin de nuit",
    company: ceecCompany,
    amount: 6200,
    submittedDate: "08/06/2026",
    period: "Juin 2026",
    delayDays: 16,
    status: "approved",
    reviewStatus: "submitted",
    createdAt: "2026-06-08 17:19:36",
    fileName: "invoice-11.pdf",
    urgent: false,
  },
];

export const auditedInvoiceStatusFilterOptions = [
  { value: "", label: "Tous statuts" },
  { value: "approved", label: "Approuvée" },
  { value: "rejected", label: "Rejetée" },
] as const;

/** Factures visibles sur le compte entreprise CEEC (23 entrées) */
export const enterpriseInvoices: Invoice[] = Array.from({ length: 23 }, (_, index) => {
  const displayId = 23 - index;
  const hospital = displayId <= 5 ? "mwangeji" : "afiadonbosco";

  return {
    id: `ent-${displayId}`,
    displayId,
    reference: `FAC-2026-${String(displayId).padStart(3, "0")}`,
    hospital,
    company: "ceec",
    amount: 1200 + displayId * 175,
    submittedDate: `${String(Math.max(1, 28 - displayId)).padStart(2, "0")}/06/2026`,
    period: "Juin 2026",
    delayDays: Math.max(1, 24 - displayId),
    status: "pending" as const,
    reviewStatus: "submitted" as const,
    createdAt: `2026-06-${String(Math.max(1, 28 - displayId)).padStart(2, "0")} 08:00:00`,
    fileName: `invoice-${displayId}.pdf`,
    urgent: false,
  };
});

/** Factures visibles sur le compte prestataire Medecin de nuit (9 entrées) */
export const hospitalInvoices: Invoice[] = [
  {
    id: "h-inv-20",
    displayId: 20,
    reference: "FAC-2026-020",
    hospital: "Medecin de nuit",
    company: ceecCompany,
    amount: 3200,
    submittedDate: "17/06/2026",
    period: "Juin 2026",
    delayDays: 7,
    status: "pending",
    reviewStatus: "inReview",
    createdAt: "2026-06-17 11:05:33",
    fileName: "invoice-20.pdf",
    urgent: false,
  },
  {
    id: "h-inv-18",
    displayId: 18,
    reference: "FAC-2026-018",
    hospital: "Medecin de nuit",
    company: ceecCompany,
    amount: 980,
    submittedDate: "15/06/2026",
    period: "Mai 2026",
    delayDays: 9,
    status: "pending",
    reviewStatus: "inReview",
    createdAt: "2026-06-15 16:40:02",
    fileName: "invoice-18.pdf",
    urgent: false,
  },
  {
    id: "h-inv-17",
    displayId: 17,
    reference: "FAC-2026-017",
    hospital: "Medecin de nuit",
    company: ceecCompany,
    amount: 4450,
    submittedDate: "14/06/2026",
    period: "Mai 2026",
    delayDays: 10,
    status: "pending",
    reviewStatus: "submitted",
    createdAt: "2026-06-14 08:55:17",
    fileName: "invoice-17.pdf",
    urgent: false,
  },
  {
    id: "h-inv-16",
    displayId: 16,
    reference: "FAC-2026-016",
    hospital: "Medecin de nuit",
    company: ceecCompany,
    amount: 22100,
    submittedDate: "13/06/2026",
    period: "Mai 2026",
    delayDays: 11,
    status: "pending",
    reviewStatus: "submitted",
    createdAt: "2026-06-13 13:12:29",
    fileName: "invoice-16.pdf",
    urgent: true,
  },
  {
    id: "h-inv-15",
    displayId: 15,
    reference: "FAC-2026-015",
    hospital: "Medecin de nuit",
    company: ceecCompany,
    amount: 760,
    submittedDate: "12/06/2026",
    period: "Mai 2026",
    delayDays: 12,
    status: "pending",
    reviewStatus: "inReview",
    createdAt: "2026-06-12 10:27:55",
    fileName: "invoice-15.pdf",
    urgent: false,
  },
  {
    id: "h-inv-14",
    displayId: 14,
    reference: "FAC-2026-014",
    hospital: "Medecin de nuit",
    company: ceecCompany,
    amount: 18900,
    submittedDate: "11/06/2026",
    period: "Mai 2026",
    delayDays: 13,
    status: "approved",
    reviewStatus: "inReview",
    createdAt: "2026-06-11 15:33:41",
    fileName: "invoice-14.pdf",
    urgent: true,
  },
  {
    id: "h-inv-13",
    displayId: 13,
    reference: "FAC-2026-013",
    hospital: "Medecin de nuit",
    company: ceecCompany,
    amount: 25640.96,
    submittedDate: "06/06/2026",
    period: "Mai 2026",
    delayDays: 20,
    status: "pending",
    reviewStatus: "inReview",
    createdAt: "2026-06-10 07:51:08",
    fileName: "invoice-13.pdf",
    urgent: true,
  },
  {
    id: "h-inv-12",
    displayId: 12,
    reference: "FAC-2026-012",
    hospital: "Medecin de nuit",
    company: ceecCompany,
    amount: 12300,
    submittedDate: "09/06/2026",
    period: "Mai 2026",
    delayDays: 15,
    status: "pending",
    reviewStatus: "submitted",
    createdAt: "2026-06-09 12:04:22",
    fileName: "invoice-12.pdf",
    urgent: false,
  },
  {
    id: "h-inv-11",
    displayId: 11,
    reference: "FAC-2026-011",
    hospital: "Medecin de nuit",
    company: ceecCompany,
    amount: 2100,
    submittedDate: "08/06/2026",
    period: "Mai 2026",
    delayDays: 16,
    status: "approved",
    reviewStatus: "submitted",
    createdAt: "2026-06-08 17:19:36",
    fileName: "invoice-11.pdf",
    urgent: false,
  },
];

export const hospitalDisputeInvoiceOptions: InvoiceOption[] = hospitalInvoices.map(
  (invoice) => ({
    value: invoice.id,
    label: `${invoice.reference} — ${invoice.company}`,
  }),
);

export function getEnterpriseInvoiceDetail(displayId: number): EnterpriseInvoiceDetail | null {
  const invoice = enterpriseInvoices.find((entry) => entry.displayId === displayId);
  if (!invoice) return null;

  if (displayId === 23) {
    return {
      displayId: 23,
      patientEmployee: null,
      company: CEEC_COMPANY_LABEL,
      hospital: "mwangeji",
      treatmentType: "forfaitaire",
      invoiceNature: "forfait_mensuel",
      providerReference: "N005",
      periodStart: "01/05/2026",
      periodEnd: "31/05/2026",
      submissionNotes:
        "Forfait mensuel — 139 familles rattachées à ce prestataire × $80.00 = $11120.00 (effectif système : 35)",
      medicalActs: [],
      totalAmount: 11120,
      coveredAmount: 11120,
      submittedAt: "24/06/2026 à 16:00",
      status: "submitted",
      fileName: invoice.fileName,
    };
  }

  const isForfait = displayId % 2 === 1;
  const totalAmount = invoice.amount;

  return {
    displayId: invoice.displayId,
    patientEmployee: displayId % 3 === 0 ? "ABEMBA ATEBA Juvenal" : null,
    company: CEEC_COMPANY_LABEL,
    hospital: invoice.hospital,
    treatmentType: isForfait ? "forfaitaire" : "standard",
    invoiceNature: isForfait ? "forfait_mensuel" : null,
    providerReference: `N${String(displayId).padStart(3, "0")}`,
    periodStart: "01/06/2026",
    periodEnd: "30/06/2026",
    submissionNotes: isForfait
      ? `Forfait mensuel — prestataire ${invoice.hospital} pour la période ${invoice.period}.`
      : `Facture classique soumise pour la période ${invoice.period}.`,
    medicalActs: isForfait
      ? []
      : [
          {
            id: `${invoice.id}-act-1`,
            code: "ACT-001",
            label: "Consultation générale",
            cost: Math.round(totalAmount * 0.45),
            date: invoice.submittedDate,
          },
          {
            id: `${invoice.id}-act-2`,
            code: "ACT-014",
            label: "Analyses laboratoire",
            cost: Math.round(totalAmount * 0.55),
            date: invoice.submittedDate,
          },
        ],
    totalAmount,
    coveredAmount: totalAmount,
    submittedAt: `${invoice.submittedDate} à 16:00`,
    status: "submitted",
    fileName: invoice.fileName,
  };
}

/** Factures approuvées à payer — compte entreprise CEEC */
export const enterpriseApprovedInvoices: Invoice[] = [
  {
    id: "ent-ap-12",
    displayId: 12,
    reference: "FAC-2026-012",
    hospital: "Medecin de nuit",
    company: "ceec",
    amount: 8450,
    submittedDate: "09/06/2026",
    period: "Juin 2026",
    delayDays: 15,
    status: "approved",
    reviewStatus: "submitted",
    createdAt: "2026-06-09 12:04:22",
    fileName: "invoice-12.pdf",
    urgent: false,
  },
  {
    id: "ent-ap-11",
    displayId: 11,
    reference: "FAC-2026-011",
    hospital: "Medecin de nuit",
    company: "ceec",
    amount: 6200,
    submittedDate: "08/06/2026",
    period: "Juin 2026",
    delayDays: 16,
    status: "approved",
    reviewStatus: "submitted",
    createdAt: "2026-06-08 17:19:36",
    fileName: "invoice-11.pdf",
    urgent: false,
  },
];

export const enterpriseInvoiceStatusFilterOptions = [
  { value: "", label: "Tous statuts" },
  { value: "submitted", label: "Soumise" },
  { value: "inReview", label: "En examen" },
  { value: "approved", label: "Approuvée" },
];

export const pendingAuditHospitalFilterOptions = toHospitalSelectOptions("Tous");

export const pendingAuditCompanyFilterOptions = toCompanySelectOptions("Toutes");

export const allInvoiceStatusFilterOptions = [
  { value: "", label: "Tous statuts" },
  { value: "inReview", label: "En examen" },
  { value: "submitted", label: "Soumise" },
  { value: "pendingAudit", label: "En attente d'audit" },
  { value: "awaitingClaims", label: "Attente Sinistre" },
  { value: "approved", label: "Validée" },
  { value: "rejected", label: "Rejetée" },
];

export function getInvoiceDisplayStatus(invoice: Invoice): InvoiceDisplayStatus {
  if (invoice.status === "approved") return "approved";
  if (invoice.status === "rejected") return "rejected";
  return invoice.reviewStatus;
}

export const pendingAuditStatusFilterOptions = [
  { value: "", label: "En attente (tous)" },
  { value: "inReview", label: "En examen" },
  { value: "pendingAudit", label: "En attente d'audit" },
];

export const invoiceHospitalFilterOptions = toHospitalSelectOptions("Tous les hôpitaux");

export const invoiceCompanyFilterOptions = toCompanySelectOptions("Toutes les entreprises");

export const invoiceOptions: InvoiceOption[] = [
  { value: "inv-001", label: "FAC-2026-001 — Medecin de nuit" },
  { value: "inv-002", label: "FAC-2026-002 — CEEC" },
  { value: "inv-003", label: "FAC-2026-003 — Polyclinique Afia" },
];

export const companyOptions = toCompanySelectOptions("Toutes les entreprises");

export const provinceOptions = [
  { value: "", label: "Toutes les provinces" },
  { value: "bas-uele", label: "Bas-Uélé" },
  { value: "equateur", label: "Équateur" },
  { value: "haut-katanga", label: "Haut-Katanga" },
  { value: "haut-lomami", label: "Haut-Lomami" },
  { value: "haut-uele", label: "Haut-Uélé" },
  { value: "ituri", label: "Ituri" },
  { value: "kasai", label: "Kasaï" },
  { value: "kasai-central", label: "Kasaï Central" },
  { value: "kasai-oriental", label: "Kasaï Oriental" },
  { value: "kinshasa", label: "Kinshasa" },
  { value: "kongo-central", label: "Kongo Central" },
  { value: "kwango", label: "Kwango" },
  { value: "kwilu", label: "Kwilu" },
  { value: "lomami", label: "Lomami" },
  { value: "lualaba", label: "Lualaba" },
  { value: "mai-ndombe", label: "Mai-Ndombe" },
  { value: "maniema", label: "Maniema" },
  { value: "mongala", label: "Mongala" },
  { value: "nord-kivu", label: "Nord-Kivu" },
  { value: "nord-ubangi", label: "Nord-Ubangi" },
  { value: "sankuru", label: "Sankuru" },
  { value: "sud-kivu", label: "Sud-Kivu" },
  { value: "sud-ubangi", label: "Sud-Ubangi" },
  { value: "tanganyika", label: "Tanganyika" },
  { value: "tshopo", label: "Tshopo" },
  { value: "tshuapa", label: "Tshuapa" },
];

export const branchOptions = [
  { value: "", label: "Toutes les antennes" },
  { value: "df", label: "Direction Financière" },
  { value: "dg", label: "Direction Générale" },
];

export const branches: Branch[] = [
  { id: "1", name: "Audit interne", province: "Kinshasa", phone: "", email: "", status: "active" },
  { id: "2", name: "Cabinet DG et DGA", province: "Kinshasa", phone: "", email: "", status: "active" },
  { id: "3", name: "Direction Financière", province: "Kinshasa", phone: "+243 81 000 0001", email: "df@ceec.cd", status: "active" },
  { id: "4", name: "Direction Générale", province: "Kinshasa", phone: "+243 81 000 0002", email: "dg@ceec.cd", status: "active" },
  { id: "5", name: "Direction des Ressources Humaines", province: "Kinshasa", phone: "", email: "", status: "active" },
  { id: "6", name: "D.P lualaba", province: "Lualaba", phone: "", email: "", status: "active" },
  { id: "7", name: "D.P Lubumbashi", province: "Haut-Katanga", phone: "", email: "", status: "active" },
  { id: "8", name: "D.P Kinshasa", province: "Kinshasa", phone: "+243 99 111 2233", email: "kinshasa@ceec.cd", status: "active" },
  { id: "9", name: "D.P Goma", province: "Nord-Kivu", phone: "", email: "", status: "active" },
  { id: "10", name: "D.P Matadi", province: "Kongo Central", phone: "", email: "", status: "active" },
  { id: "11", name: "D.P Kisangani", province: "Tshopo", phone: "", email: "", status: "active" },
  { id: "12", name: "D.P Mbuji-Mayi", province: "Kasaï Oriental", phone: "", email: "", status: "active" },
  { id: "13", name: "D.P Kananga", province: "Kasaï Central", phone: "", email: "", status: "active" },
  { id: "14", name: "Service Informatique", province: "Kinshasa", phone: "", email: "it@ceec.cd", status: "active" },
  { id: "15", name: "Service Juridique", province: "Kinshasa", phone: "", email: "", status: "active" },
  { id: "16", name: "Service Communication", province: "Kinshasa", phone: "", email: "", status: "active" },
  { id: "17", name: "Antenne Kolwezi", province: "Lualaba", phone: "", email: "", status: "active" },
  { id: "18", name: "Antenne Bukavu", province: "Sud-Kivu", phone: "", email: "", status: "active" },
  { id: "19", name: "Antenne Kindu", province: "Maniema", phone: "", email: "", status: "inactive" },
  { id: "20", name: "Antenne Bandundu", province: "Kwilu", phone: "", email: "", status: "active" },
  { id: "21", name: "Antenne Mbandaka", province: "Équateur", phone: "", email: "", status: "active" },
];

export const statusOptions = [
  { value: "", label: "Tous" },
  { value: "active", label: "Actif" },
  { value: "inactive", label: "Inactif" },
];

export const providerTypeOptions = [
  { value: "", label: "Tous les types" },
  { value: "HÔPITAL", label: "Hôpital" },
  { value: "PHARMACIE", label: "Pharmacie" },
  { value: "CABINET MÉDICAL", label: "Cabinet médical" },
  { value: "CLINIQUE", label: "Clinique" },
];

export const providerProvinceOptions = [
  { value: "", label: "Par province" },
  { value: "Kinshasa", label: "Kinshasa" },
  { value: "Kasaï-Central", label: "Kasaï-Central" },
  { value: "Kasaï-Oriental", label: "Kasaï-Oriental" },
  { value: "Haut-Katanga", label: "Haut-Katanga" },
  { value: "Kwilu", label: "Kwilu" },
];

export const hospitalOptions = toHospitalSelectOptions("Tous les hôpitaux");

export const monthOptions = [
  { value: "", label: "Tous les mois" },
  { value: "01", label: "Janvier" },
  { value: "02", label: "Février" },
  { value: "03", label: "Mars" },
];

export const yearOptions = [
  { value: "2026", label: "2026" },
  { value: "2025", label: "2025" },
];

export const actTypeOptions = [
  { value: "", label: "Tous les actes" },
  { value: "consultation", label: "Consultation" },
  { value: "hospitalisation", label: "Hospitalisation" },
];

export const actCategoryOptions = [
  { value: "", label: "Toutes les catégories" },
  { value: "consultation", label: "Consultation" },
  { value: "laboratoire", label: "Laboratoire" },
  { value: "centre_specialise", label: "Centre spécialisé" },
  { value: "imagerie", label: "Imagerie" },
  { value: "chirurgie", label: "Chirurgie" },
  { value: "hospitalisation", label: "Hospitalisation" },
];

export const standardActCategoryOptions = [
  { value: "", label: "-- Sélectionner --" },
  { value: "ACTE CHIRURGICALE/ACTE SPECIAL", label: "ACTE CHIRURGICALE/ACTE SPECIAL" },
  { value: "HOSPITALISATION", label: "HOSPITALISATION" },
  { value: "LABORATOIRE", label: "LABORATOIRE" },
  { value: "CENTRE SPÉCIALISÉ", label: "CENTRE SPÉCIALISÉ" },
  { value: "DENTISTERIE", label: "DENTISTERIE" },
  { value: "PHARMACIE", label: "PHARMACIE" },
  { value: "IMAGERIE", label: "IMAGERIE" },
  { value: "CONSULTATION", label: "CONSULTATION" },
  { value: "CHAMBRE/OBSERVATION", label: "CHAMBRE/OBSERVATION" },
];

export const standardActCodes: StandardActCode[] = [
  { id: "1", code: "COR01", label: "CODE REFRACTION ACTE CHIRURGICALE/ACTE SPECIAL", category: "ACTE CHIRURGICALE/ACTE SPECIAL", specialty: "", description: "" },
  { id: "2", code: "COR02", label: "CODE REFRACTION HOSPITALISATION", category: "HOSPITALISATION", specialty: "", description: "" },
  { id: "3", code: "COR05", label: "CODE REFRACTION LABORATOIRE", category: "LABORATOIRE", specialty: "", description: "" },
  { id: "4", code: "COR08", label: "CODE REFRACTION DENTISTERIE", category: "DENTISTERIE", specialty: "", description: "" },
  { id: "5", code: "COR10", label: "CODE REFRACTION PHARMACIE", category: "PHARMACIE", specialty: "", description: "" },
  { id: "6", code: "COR15", label: "CODE REFRACTION IMAGERIE", category: "IMAGERIE", specialty: "", description: "" },
  { id: "7", code: "COR20", label: "CODE REFRACTION CONSULTATION", category: "CONSULTATION", specialty: "", description: "" },
  { id: "8", code: "COR25", label: "CODE REFRACTION CHAMBRE/OBSERVATION", category: "CHAMBRE/OBSERVATION", specialty: "", description: "" },
  { id: "9", code: "RAAMC", label: "AUXILIAIRE KINESITHERAPEUTE", category: "KINESITHERAPEUTE", specialty: "", description: "" },
  { id: "10", code: "RAAMI", label: "AUXILIAIRE MEDICAUX SOINS INFIRMIER", category: "SOINS INFIRMIER", specialty: "", description: "" },
];

export const diagnosticTypeOptions = [
  { value: "", label: "-- Sélectionner --" },
  { value: "INFECTION", label: "INFECTION" },
  { value: "CARDIOVASCULAIRE", label: "CARDIOVASCULAIRE" },
  { value: "RESPIRATOIRE", label: "RESPIRATOIRE" },
  { value: "DIGESTIF", label: "DIGESTIF" },
  { value: "NEUROLOGIQUE", label: "NEUROLOGIQUE" },
  { value: "TRAUMATISME", label: "TRAUMATISME" },
];

export const standardDiagnosticCodes: StandardDiagnosticCode[] = [
  { id: "1", code: "11", label: "ARYTMIE CARDIAQUE", type: "INFECTION", description: "" },
  { id: "2", code: "12", label: "BRONCHITE AIGUE", type: "RESPIRATOIRE", description: "" },
  { id: "3", code: "13", label: "GASTRO-ENTÉRITE", type: "DIGESTIF", description: "" },
  { id: "4", code: "14", label: "HYPERTENSION ARTÉRIELLE", type: "CARDIOVASCULAIRE", description: "" },
  { id: "5", code: "15", label: "MIGRAINE", type: "NEUROLOGIQUE", description: "" },
];

export const hospitalActsSummaries: HospitalActsSummary[] = [
  { id: "1", hospital: "CLINIQUE CENTRALE DE (KIKWIT) KWILU", actCount: 0 },
  { id: "2", hospital: "afiadonbosco", actCount: 3264 },
  { id: "3", hospital: "ARIEL MEDICAL INSTITUTE", actCount: 0 },
  { id: "4", hospital: "CENTRE BOTOUR", actCount: 0 },
  { id: "5", hospital: "CENTRE MEDICAL D'EXCELLENCE", actCount: 0 },
  { id: "6", hospital: "CLINIQUE SAINT LUC", actCount: 0 },
  { id: "7", hospital: "HOPITAL GENERAL DE KINSHASA", actCount: 0 },
  { id: "8", hospital: "POLYCLINIQUE AFIA DON BOSCO", actCount: 0 },
  { id: "9", hospital: "CENTRE MEDICAL DIAMANT", actCount: 0 },
  { id: "10", hospital: "CLINIQUE LA REFERENCE", actCount: 0 },
];

export const hospitalActDetails: HospitalActDetail[] = [
  { id: "1", hospitalId: "2", code: "ACTE 1", label: "POSE VALVE VENTRICULOPERITONEALEENFANT", careType: "nursing", costUsd: "3 750,00", delayDays: 3 },
  { id: "2", hospitalId: "2", code: "ACTE 10", label: "ABLATION DU CATHETER D HEMODIALYSE", careType: "consultation", costUsd: "50,00", delayDays: 3 },
  { id: "3", hospitalId: "2", code: "ACTE 100", label: "LIGATURE DES ARTERES UTERINES", careType: "surgery", costUsd: "600,00", delayDays: 3 },
  { id: "4", hospitalId: "2", code: "ACTE 1000", label: "FIBRINOGENE", careType: "imagingLab", costUsd: "50,00", delayDays: 3 },
  { id: "5", hospitalId: "2", code: "ACTE 1001", label: "FORMULE LEUCOCYTAIRE", careType: "imagingLab", costUsd: "5,00", delayDays: 3 },
  { id: "6", hospitalId: "2", code: "ACTE 1002", label: "TRANSAMINASE SGOT (ASAT)", careType: "imagingLab", costUsd: "15,00", delayDays: 3 },
  { id: "7", hospitalId: "2", code: "ACTE 1003", label: "TRANSAMINASE SGPT (ALAT)", careType: "imagingLab", costUsd: "15,00", delayDays: 3 },
  { id: "8", hospitalId: "2", code: "ACTE 1004", label: "TRANSAMINASES (ASAT + ALAT)", careType: "imagingLab", costUsd: "25,00", delayDays: 3 },
  { id: "9", hospitalId: "2", code: "ACTE 1005", label: "TRIGLYCERIDES", careType: "imagingLab", costUsd: "10,00", delayDays: 3 },
  { id: "10", hospitalId: "2", code: "ACTE 1006", label: "TROPONINE", careType: "imagingLab", costUsd: "35,00", delayDays: 3 },
  { id: "11", hospitalId: "2", code: "ACTE 1007", label: "UREE SANGUINE", careType: "imagingLab", costUsd: "10,00", delayDays: 3 },
];

export function getHospitalActDetails(hospitalId: string): HospitalActDetail[] {
  return hospitalActDetails.filter((act) => act.hospitalId === hospitalId);
}

export function getHospitalActsForPackage(hospitalName: string): HospitalActDetail[] {
  if (!hospitalName) return [];
  const summary = hospitalActsSummaries.find(
    (item) => item.hospital.toLowerCase() === hospitalName.toLowerCase(),
  );
  if (!summary) return [];
  return getHospitalActDetails(summary.id);
}

export const hospitalActs: HospitalAct[] = [
  { id: "1", hospital: "Polyclinique Afia Don Bosco", code: "CONS-GEN", label: "Consultation générale", hospitalRate: "18 USD", status: "active" },
  { id: "2", hospital: "Polyclinique Afia Don Bosco", code: "LAB-NFS", label: "Numération formule sanguine", hospitalRate: "14 USD", status: "active" },
  { id: "3", hospital: "Clinique Saint Luc", code: "CONS-SPEC", label: "Consultation spécialisée", hospitalRate: "30 USD", status: "active" },
  { id: "4", hospital: "Clinique Saint Luc", code: "IMG-ECHO", label: "Échographie abdominale", hospitalRate: "40 USD", status: "active" },
  { id: "5", hospital: "Hôpital Général de Kinshasa", code: "CHIR-APP", label: "Appendicectomie", hospitalRate: "500 USD", status: "active" },
  { id: "6", hospital: "Hôpital Général de Kinshasa", code: "HOSP-NUIT", label: "Hospitalisation nuit", hospitalRate: "135 USD", status: "inactive" },
  { id: "7", hospital: "Centre Médical Diamant", code: "CONS-GEN", label: "Consultation générale", hospitalRate: "16 USD", status: "active" },
  { id: "8", hospital: "Centre Médical Diamant", code: "IMG-RX", label: "Radiographie standard", hospitalRate: "22 USD", status: "active" },
];

export const providerMedicalActsStats = {
  aiBatchSize: 20,
} as const;

export const providerMedicalActs: ProviderMedicalAct[] =
  providerMedicalActsData as ProviderMedicalAct[];

export function getProviderMedicalActsStats() {
  return {
    total: providerMedicalActs.length,
    pendingValidation: providerMedicalActs.filter((act) => act.pendingValidation).length,
    aiBatchSize: providerMedicalActsStats.aiBatchSize,
  };
}

export const providerMedicalActsCsvExample = `code,libelle,cout
CONS001,Consultation générale,50.00
PHARM-010,Paracétamol 500mg,2.50
CHIR-200,Petite chirurgie ambulatoire,180.00`;

export const categoryValidationStats = {
  toValidate: 53,
  classified: 7291,
  manuallyValidated: 4571,
  lowConfidence: 53,
  unclassified: 0,
};

export const categoryValidationHospitalOptions = toHospitalSelectOptions("Tous");

export const categoryValidationActionOptions = [
  { value: "pharmacie", label: "Pharmacie", shortLabel: "Pharmacie" },
  { value: "nursing", label: "Nursing", shortLabel: "Nursing" },
  { value: "imagerie", label: "Imagerie", shortLabel: "Imagerie" },
  { value: "laboratoire", label: "Laboratoire", shortLabel: "Laboratoire" },
  {
    value: "consultation",
    label: "Consultation (générale, spécialisée)",
    shortLabel: "Consultation (gén., spéc.)",
  },
  { value: "chirurgie", label: "Chirurgie", shortLabel: "Chirurgie" },
  {
    value: "support",
    label: "Support et rééducation",
    shortLabel: "Support & rééduc.",
  },
  { value: "hospitalisation", label: "Hospitalisation", shortLabel: "Hospitalisation" },
  {
    value: "gyneco",
    label: "Gynéco-obstétrique",
    shortLabel: "Gynéco-obstétrique",
  },
  { value: "transport", label: "Transport", shortLabel: "Transport" },
  { value: "ophtalmologie", label: "Ophtalmologie", shortLabel: "Ophtalmologie" },
  { value: "dentisterie", label: "Dentisterie", shortLabel: "Dentisterie" },
];

export const categoryValidationFilterOptions = [
  { value: "toValidate", label: "À valider" },
  { value: "classified", label: "Classés (fiabilisés)" },
  { value: "manuallyValidated", label: "Validés manuellement" },
  { value: "lowConfidence", label: "Faible confiance" },
  { value: "unclassified", label: "Non classés" },
];

export const categoryValidationCategoryOptions = [
  { value: "", label: "Toutes" },
  { value: "pharmacie", label: "Pharmacie" },
  { value: "nursing", label: "Nursing" },
  { value: "imagerie", label: "Imagerie" },
  { value: "laboratoire", label: "Laboratoire" },
  { value: "consultation", label: "Consultation (générale, spécialisée)" },
  { value: "chirurgie", label: "Chirurgie" },
  { value: "support", label: "Support et rééducation" },
  { value: "hospitalisation", label: "Hospitalisation" },
  { value: "gyneco", label: "Gynéco-obstétrique" },
  { value: "transport", label: "Transport" },
  { value: "ophtalmologie", label: "Ophtalmologie" },
  { value: "dentisterie", label: "Dentisterie" },
];

export const categoryValidations: CategoryValidation[] = [
  { id: "1", code: "ACTE 74", label: "ASLO", hospital: "mwangeji", filterStatus: "toValidate", proposedCategory: "CONSULTATION (GÉNÉRALE, SPÉCIALISÉE)", confidence: 55, confidenceSource: "rule", selectedCategory: "consultation" },
  { id: "2", code: "ACTE 75", label: "ASP", hospital: "mwangeji", filterStatus: "toValidate", proposedCategory: "CONSULTATION (GÉNÉRALE, SPÉCIALISÉE)", confidence: 55, confidenceSource: "rule", selectedCategory: "consultation" },
  { id: "3", code: "ACTE 98", label: "BILIRUBINE", hospital: "mwangeji", filterStatus: "toValidate", proposedCategory: "IMAGERIE, LABO ET DIAGNOSTIC", confidence: 62, confidenceSource: "rule", selectedCategory: "imagerie" },
  { id: "4", code: "ACTE 101", label: "DRAINAGE PLEURALE", hospital: "mwangeji", filterStatus: "toValidate", proposedCategory: "CHIRURGIE", confidence: 48, confidenceSource: "rule", selectedCategory: "chirurgie" },
  { id: "5", code: "ACTE 102", label: "ECHOGRAPHIE ABDOMINALE", hospital: "mwangeji", filterStatus: "toValidate", proposedCategory: "IMAGERIE, LABO ET DIAGNOSTIC", confidence: 71, confidenceSource: "ai", selectedCategory: "imagerie" },
  { id: "6", code: "ACTE 1001", label: "FORMULE LEUCOCYTAIRE", hospital: "afiadonbosco", filterStatus: "toValidate", proposedCategory: "IMAGERIE, LABO ET DIAGNOSTIC", confidence: 58, confidenceSource: "rule", selectedCategory: "imagerie" },
  { id: "7", code: "ACTE 100", label: "LIGATURE DES ARTERES UTERINES", hospital: "afiadonbosco", filterStatus: "toValidate", proposedCategory: "GYNÉCO-OBSTÉTRIQUE", confidence: 66, confidenceSource: "rule", selectedCategory: "gyneco" },
  { id: "8", code: "ACTE 10", label: "ABLATION DU CATHETER D HEMODIALYSE", hospital: "afiadonbosco", filterStatus: "lowConfidence", proposedCategory: "CONSULTATION (GÉNÉRALE, SPÉCIALISÉE)", confidence: 42, confidenceSource: "rule", selectedCategory: "consultation" },
  { id: "9", code: "LAB-CRP", label: "PROTEINE C REACTIVE", hospital: "Polyclinique Afia Don Bosco", filterStatus: "classified", proposedCategory: "IMAGERIE, LABO ET DIAGNOSTIC", confidence: 88, confidenceSource: "ai", selectedCategory: "imagerie" },
  { id: "10", code: "IMG-IRM", label: "IRM LOMBAIRE", hospital: "Clinique Saint Luc", filterStatus: "manuallyValidated", proposedCategory: "IMAGERIE, LABO ET DIAGNOSTIC", confidence: 91, confidenceSource: "ai", selectedCategory: "imagerie" },
];
